import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'capitalize'})
export class CapitalizePipe implements PipeTransform {

    transform(value: string, args: any[]): string {
        if (value) {
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/pipes/capitalize.pipe.ts